import {
  fontStacks as fableticsFontStacks,
  fonts as fableticsFonts,
} from '../fabletics/fonts';

/* syncing up Yitty's fonts to match Fabletics's, do not customize these */
export const fontStacks = {
  ...fableticsFontStacks,
};

export const fonts = [...fableticsFonts];
